import React, { useEffect, useState } from "react";
import Cookie from "js-cookie";
import { useLogout } from "../../hooks/useLogout";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const UserEndorsement = () => {
  const [userData, setUserData] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false); // State for dropdown
  const { logout } = useLogout();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = Cookie.get("accessToken");
    fetch(process.env.REACT_APP_BACKEND_URI + `user/self?accessToken=${accessToken}`)
      .then((response) => response.json())
      .then((data) => setUserData(data))
      .catch((error) => console.error("Error fetching user data:", error));
  }, []);

  if (!userData) return <div>Loading...</div>;

  const handleLogout = () => {
    logout();
    Cookies.remove('accessToken');
    Cookies.remove('adminKey');
    setShowDropdown(false); // Close the dropdown after logout
    navigate('/');
  };

  return (
    <div
      className="relative flex items-center pl-3 border-[2px] border-[#303030] bg-[#303030] rounded-md shadow-sm cursor-pointer" // Added cursor-pointer
      onClick={() => setShowDropdown(!showDropdown)} // Toggle dropdown
    >
      <span className="text-sm font-medium text-gray-200">{userData.username}</span>
      <div className="ml-3 w-8 h-8 flex items-center">
        <img
          src={userData?.userLogo}
          alt={userData.username}
          className="w-full h-full object-cover rounded-md"
        />
      </div>
      {showDropdown && ( // Conditionally render the dropdown
        <div className="absolute -right-1 mt-25 py-2 w-32 bg-[#121212] rounded-b-md shadow-lg">
          <button className="block px-4 py-2 text-center text-sm text-gray-200 w-full" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserEndorsement;
